import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";
import { TooltipProvider } from "@/components/ui/tooltip";
import { ErrorBoundary } from "@/components/ui/error-boundary";
import App from "./App";
import { SessionProvider } from "./api/session";
import { SessionQueryProvider } from "./api/SessionQueryProvider";
import { ToastProvider } from "./components/ToastProvider";
import "./index.css";

const container = document.getElementById("root");
if (!container) throw new Error("#root not found");

createRoot(container).render(
  <StrictMode>
    <SessionProvider>
      <SessionQueryProvider>
        <ToastProvider>
          <TooltipProvider delayDuration={300} skipDelayDuration={100}>
            <BrowserRouter>
              {/* Crash-proof law (CORE-168): a failure above the routes —
                  the shell chunk itself, a rejected deploy-swapped lazy
                  import — must render the error card, never unmount the
                  app into a blank page. Only a fresh load recovers a
                  rejected dynamic import, so the retry reloads. */}
              <ErrorBoundary title="Corenote hit an unexpected error">
                <App />
              </ErrorBoundary>
            </BrowserRouter>
          </TooltipProvider>
        </ToastProvider>
      </SessionQueryProvider>
    </SessionProvider>
  </StrictMode>,
);

// Development-only accessibility auditing in the console.
if (import.meta.env.DEV) {
  void Promise.all([
    import("@axe-core/react"),
    import("react"),
    import("react-dom"),
  ]).then(([reactAxe, react, reactDom]) => {
    reactAxe.default(react, reactDom, 1000);
  });
}
